import { render, staticRenderFns } from "./AddEditSKUSModal.vue?vue&type=template&id=5834d328"
import script from "./AddEditSKUSModal.vue?vue&type=script&lang=js"
export * from "./AddEditSKUSModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports